<ng-container
        *ngIf="question.groupedGlobalizationConfig.length === 1 && question.groupedTypes[0] !== QuestionConfigType.Goals">
    <div class="question-title">
        <p style="margin-left: 5px"
           [innerHtml]="getParsedDescription(getText(question.groupedGlobalizationConfig[0], 'title'))"></p>
        <div
                class="tooltip"
                *ngIf="getText(question.groupedGlobalizationConfig[0], 'instructions')"
                [matTooltip]="getText(question.groupedGlobalizationConfig[0], 'instructions')">?
        </div>
    </div>
</ng-container>

<ion-grid class="slider">
    <ion-row>
        <ion-col [size]="2"></ion-col>
        <ion-col class="description-modal"
                 [size]="10 / question.typeConfig.possibleValues.length"
                 *ngFor="
                                      let opValue of question.typeConfig.possibleValues;
                                      let vIndex = index
                                    "
                 [style.color]="question.typeConfig.colors[vIndex]">
            <b>{{ getText(question.typeConfig.possibleValuesGlobalized, vIndex) }}</b>
            <ion-icon
                    *ngIf="typeConfigDescriptionEnabled && question.typeConfig.description && question.typeConfig.description[selectedLanguage][vIndex]"
                    class="bp-question-fill"
                    [matTooltip]="descriptionTooltip"
                    (mouseenter)="setTooltip(question, vIndex)"
                    (click)="openDescriptionConcept(question.typeConfig.possibleValuesGlobalized[selectedLanguage], question.typeConfig.description[selectedLanguage], vIndex)">
            </ion-icon>
        </ion-col>
    </ion-row>
    <ng-container *ngFor=" let globConfig of question.groupedGlobalizationConfig;  let gIndex = index ">
        <ion-row
                *ngIf="question.viewType === QuestionViewType.Top || question.groupedViewType[gIndex] === QuestionViewType.Top">
            <ion-col [size]="12" tooltip>
                <ng-container
                        *ngIf="!question.groupedTypes || question.groupedTypes[gIndex] !== QuestionConfigType.Goals">
                    <div class="description" *ngIf="question.groupedGlobalizationConfig.length > 1">
                        <p [innerHtml]=" getParsedDescription(getText(globConfig, 'title'))"
                           [ngClass]="{highlight:
                                                      highlightSelfOrManagerEvalAnswer &&
                                                        question.groupedTypes && question.groupedTypes[gIndex] &&
                                                        (question.groupedTypes[gIndex] === QuestionConfigType.GoalsFinalGrade ||
                                                          question.groupedTypes[gIndex] === QuestionConfigType.FinalGrade ||
                                                          question.groupedTypes[gIndex] === QuestionConfigType.PrinciplesFinalGrade ||
                                                          question.groupedTypes[gIndex] === QuestionConfigType.LeadershipFinalGrade)      }">
                        </p>

                        <div class="tooltip" *ngIf="getText(globConfig, 'instructions')"
                             [matTooltip]="getText(globConfig, 'instructions')">
                            ?
                        </div>
                    </div>

                    <ng-container *ngIf="showRequiredBadge(  formGroup,  question.groupedIndexes[gIndex])">
                        <p class="required">
                            ({{ "generic.obligatoryField" | translate }})
                        </p>
                    </ng-container>
                </ng-container>
                <div class="goal"
                     *ngIf="question.groupedTypes && question.groupedTypes[gIndex] === QuestionConfigType.Goals ">
                    <ion-grid>
                        <ion-row>
                            <ion-col size="1">
                                <ion-icon color="primary"
                                          class="bp-view"
                                          (click)="viewGoalModal(question.groupedGoals[gIndex])"
                                ></ion-icon>
                            </ion-col>
                            <ion-col size="11" class="goals-detail">
                                <p class="title">
                                    {{ question.groupedGoals[gIndex].title }}
                                    <span
                                            class="tooltip"
                                            *ngIf="question.groupedGoals[gIndex].description"
                                            [matTooltip]="question.groupedGoals[gIndex].description"
                                    >i</span>
                                </p>
                                <div class="deadline">
                                    <p class="date">
                                        {{ "generic.deadline" | translate }}:
                                        <b>{{ question.groupedGoals[gIndex].deadline  | date : "dd/MM/yyyy" }}</b>
                                    </p>
                                    <p class="weight">
                                        {{ "generic.weight" | translate }}:
                                        <b>{{ question.groupedGoals[gIndex].weight }}%</b>
                                    </p>
                                    <div class="progress-bar-container"
                                         [ngClass]="{
                                                            primary: getProgressBarColor(
                                                              question.groupedGoals[gIndex],
                                                              'primary'
                                                            ),
                                                            danger: getProgressBarColor(
                                                              question.groupedGoals[gIndex],
                                                              'danger'
                                                            ),
                                                            warning: getProgressBarColor(
                                                              question.groupedGoals[gIndex],
                                                              'warning'
                                                            )
                                                          }">
                                        <div class="prohress-bar">
                                                        <span
                                                                [ngStyle]="
                                                            getProgressBarLength(
                                                              question.groupedGoals[gIndex]
                                                            )
                                                          "
                                                        ></span>
                                        </div>
                                        <div class="progress-bar-status">
                                            {{ question.groupedGoals[gIndex].currentProgress }}%
                                        </div>
                                    </div>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row size="12"
                                 *ngIf="showRequiredBadge(formGroup, question.groupedIndexes[gIndex] )">
                            <p class="required">
                                ({{ "generic.obligatoryField" | translate }})
                            </p>
                        </ion-row>
                    </ion-grid>
                </div>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col *ngIf="question.viewType === QuestionViewType.Left 
                                        || question.viewType === null
                                        || question.viewType === undefined
                                        || question.groupedViewType[gIndex] === QuestionViewType.Left 
                                        || question.groupedViewType[gIndex] === null
                                        || question.groupedViewType[gIndex] === undefined"
                     [size]="2" tooltip>
                <ng-container
                        *ngIf=" !question.groupedTypes || question.groupedTypes[gIndex] !== QuestionConfigType.Goals">
                    <div class="description" *ngIf="question.groupedGlobalizationConfig.length > 1">
                        <p
                                [innerHtml]="getParsedDescription(getText(globConfig, 'title'))"
                                [ngClass]="{
                                            highlight:
                                                highlightSelfOrManagerEvalAnswer &&
                                                question.groupedTypes &&
                                                question.groupedTypes[gIndex] &&
                                                (question.groupedTypes[gIndex] === QuestionConfigType.GoalsFinalGrade ||
                                                    question.groupedTypes[gIndex] === QuestionConfigType.FinalGrade ||
                                                    question.groupedTypes[gIndex] === QuestionConfigType.PrinciplesFinalGrade ||
                                                    question.groupedTypes[gIndex] === QuestionConfigType.LeadershipFinalGrade)
                                        }"
                        ></p>

                        <div class="tooltip" *ngIf="getText(globConfig, 'instructions')"
                             [matTooltip]="getText(globConfig, 'instructions')">?
                        </div>
                    </div>

                    <ng-container *ngIf="showRequiredBadge(  formGroup,  question.groupedIndexes[gIndex])">
                        <p class="required">
                            ({{ "generic.obligatoryField" | translate }})
                        </p>
                    </ng-container>
                </ng-container>
                <div class="goal"
                     *ngIf="question.groupedTypes && question.groupedTypes[gIndex] === QuestionConfigType.Goals">
                    <ion-grid>
                        <ion-row>
                            <ion-col size="2">
                                <ion-icon color="primary" class="bp-view"
                                          (click)="viewGoalModal(question.groupedGoals[gIndex])"></ion-icon>
                            </ion-col>
                            <ion-col size="8" class="goals-detail">
                                <p class="title">
                                    {{ question.groupedGoals[gIndex].title }}
                                </p>
                                <div class="deadline">
                                    <p class="date">
                                        {{ "generic.deadline" | translate }}:
                                        <b>{{ question.groupedGoals[gIndex].deadline  | date : "dd/MM/yyyy" }}</b>
                                    </p>
                                    <p class="weight">
                                        {{ "generic.weight" | translate }}:
                                        <b>{{ question.groupedGoals[gIndex].weight }}%</b>
                                    </p>
                                    <div
                                            class="progress-bar-container"
                                            [ngClass]="{
                                                        primary: getProgressBarColor(question.groupedGoals[gIndex], 'primary'),
                                                        danger: getProgressBarColor(question.groupedGoals[gIndex], 'danger'),
                                                        warning: getProgressBarColor(question.groupedGoals[gIndex], 'warning')
                                                    }"
                                    >
                                        <div class="prohress-bar">
                                                        <span
                                                                [ngStyle]="
                                                            getProgressBarLength(
                                                              question.groupedGoals[gIndex]
                                                            )
                                                          "
                                                        ></span>
                                        </div>
                                        <div class="progress-bar-status">
                                            {{ question.groupedGoals[gIndex].currentProgress }}%
                                        </div>
                                    </div>
                                </div>
                            </ion-col>
                            <span class="tooltip" *ngIf="question.groupedGoals[gIndex].description"
                                  [matTooltip]="question.groupedGoals[gIndex].description">i</span>
                        </ion-row>
                        <ion-row size="12"
                                 *ngIf="showRequiredBadge(formGroup, question.groupedIndexes[gIndex])">
                            <p class="required">({{ "generic.obligatoryField" | translate }})</p>
                        </ion-row>
                    </ion-grid>
                </div>
            </ion-col>
            <ion-col size="2"
                     *ngIf="question.viewType !== QuestionViewType.Left
                                        && question.viewType !== null
                                        && question.viewType !== undefined
                                        && question.groupedViewType[gIndex] !== QuestionViewType.Left 
                                        && question.groupedViewType[gIndex] !== null
                                        && question.groupedViewType[gIndex] !== undefined">
            </ion-col>
            <ion-col *ngFor="let opValue of question.typeConfig.possibleValues; let vIndex = index "
                     [size]="10 / question.typeConfig.possibleValues.length">
                <div class="circle"
                     [ngClass]="{ selected: formGroup.get('field' + question.groupedIndexes[gIndex]).value + (isManagerComment ? 'Comment' : '') === opValue }"
                     [style.borderColor]="question.typeConfig.colors[vIndex]"
                     [style.backgroundColor]=" formGroup.get('field' + question.groupedIndexes[gIndex] + (isManagerComment ? 'Comment' : ''))
                                    .value === opValue
                                    ? question.typeConfig.colors[vIndex]
                                    : 'transparent' "
                     (click)=" setRangeValue('field' + question.groupedIndexes[gIndex] + (isManagerComment ? 'Comment' : ''), opValue, question.typeConfig, vIndex) "
                ></div>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="evaluation && getQuestionAnswer(question, gIndex)">
            <app-question-answer
                    style="width: 100%"
                    [question]="question"
                    [evaluation]="evaluation"
                    [groupIndex]="gIndex"
                    [managerAnswer]="managerAnswer"
                    [answer]="getQuestionAnswer(question, gIndex)"
            ></app-question-answer>
        </ion-row>
    </ng-container>
</ion-grid>